import * as React from "react";

// const LeftItem = styled(Paper)(({theme}) => ({
// 	backgroundColor: "rgb(25, 118, 210)",
// 	...theme.typography.body2,
// 	textAlign: "left",
// 	color: "white",
// }));
//
// const RightItem = styled(Paper)(({theme}) => ({
// 	backgroundColor: "rgb(25, 118, 210)",
// 	...theme.typography.body2,
// 	textAlign: "right",
// 	color: "white",
// }));

export function DefaultHeader(props: any) {
	if (!props.order.policyId)
		return (
			<div>
			
			</div>
		);
	
	
	// const order = props.order;
	return (
		<div>
		
		</div>
	);
	
	// return (
	//     <div>
	//         <Grid container columns={2}>
	//             <Grid md={2}>
	//                 <LeftItem>{order.mainApplicant.address.street ?? "No street name"} {order.mainApplicant.address.houseNumber} {order.mainApplicant.address.houseNumberAddition}</LeftItem>
	//             </Grid>
	//             <Grid md={2}>
	//                 <LeftItem>{order.mainApplicant.address.postalCode}</LeftItem>
	//             </Grid>
	//             <Grid md={2} >
	//                 <RightItem>{order.policyId}</RightItem>
	//             </Grid>
	//         </Grid>
	//     </div>
	// )
}
